/** Import-step API endpoints, merged into the platform API client. */
export const importsApiEndpoints: Record<string, string> = {
  importAttachments: "POST:/projects/:pk/import/attachments",
};
